import { useRouteLoaderData, useSubmit } from "react-router";
import { type RootLoader } from "~/root";
import { logError } from "~/services/logging";
import { CSRFKey } from "~/services/security/csrf/csrfKey";

const options = { method: "post", encType: "multipart/form-data" } as const;
const handleSubmissionError = (error: unknown) =>
  logError({ message: "An error occurred during form submission:", error });

export function useFileHandler() {
  const csrf = useRouteLoaderData<RootLoader>("root")?.csrf ?? "";
  const submit = useSubmit();
  return {
    onFileUpload: (fieldName: string, file: File | undefined) => {
      if (!file) return;

      const formData = new FormData();
      formData.append("_action", `fileUpload.${fieldName}`);
      formData.append(CSRFKey, csrf);
      formData.append(fieldName, file);
      submit(formData, options).catch(handleSubmissionError);
    },
    onFileDelete: (fieldName: string) => {
      const formData = new FormData();
      formData.append("_action", `deleteFile.${fieldName}`);
      formData.append(CSRFKey, csrf);
      submit(formData, options).catch(handleSubmissionError);
    },
  };
}
